<div class="expression-editor w-full">
    <!-- Tab Headers with Icon -->
    <div *ngIf="!compact && showLibrary" class="flex overflow-x-auto overflow-y-hidden border-b border-gray-200 dark:border-gray-700">
        <button type="button" (click)="currentTab = 0" [ngClass]="{
                'border-blue-500 text-blue-500 font-semibold': currentTab === 0,
                'text-gray-600 dark:text-gray-400': currentTab !== 0
            }"
            class="px-4 py-3 -mb-px border-b-2 font-medium text-sm focus:outline-none flex items-center whitespace-nowrap flex-shrink-0 transition-colors">
            <fa-icon [icon]="['fal', 'code']" class="mr-2" size="lg"></fa-icon>
            <span>{{ 'SystemAdmin.Components.ExpressionEditor.Tabs.Builder' | translate }}</span>
        </button>
        <button type="button" (click)="currentTab = 1" [ngClass]="{
                'border-blue-500 text-blue-500 font-semibold': currentTab === 1,
                'text-gray-600 dark:text-gray-400': currentTab !== 1
            }"
            class="px-4 py-3 -mb-px border-b-2 font-medium text-sm focus:outline-none flex items-center whitespace-nowrap flex-shrink-0 transition-colors">
            <fa-icon [icon]="['fal', 'books']" class="mr-2" size="lg"></fa-icon>
            <span>{{ 'SystemAdmin.Components.ExpressionEditor.Tabs.Library' | translate }}</span>
        </button>
    </div>

    <!-- Tab Content -->
    <div [ngClass]="compact ? 'p-0' : 'p-6'">
        <!-- Builder Tab -->
        <div *ngIf="compact || !showLibrary || currentTab === 0">
            <!-- Sample Value & Preview Button Row -->
            <div *ngIf="showSampleTools && !compact" class="grid grid-cols-1 lg:grid-cols-[1fr,auto] gap-4 mb-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        {{ 'SystemAdmin.Components.ExpressionEditor.SampleValue' | translate }}
                    </label>
                    <div class="relative">
                        <!-- Number Input (valueType === 3 or 4 or 11) -->
                        <input *ngIf="valueType === 3 || valueType === 4 || valueType === 11" type="number"
                            [value]="sampleValue" (input)="handleSampleValueInput($any($event.target).value)"
                            [disabled]="disabled || readonly"
                            class="w-full px-3 py-2 pr-16 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-slate-800 text-gray-900 dark:text-gray-100 disabled:bg-gray-100 dark:disabled:bg-slate-900 disabled:cursor-not-allowed">

                        <!-- Boolean Checkbox (valueType === 5) -->
                        <div *ngIf="valueType === 5" class="flex items-center h-10">
                            <label class="flex items-center cursor-pointer">
                                <input type="checkbox" [checked]="sampleValue"
                                    (change)="handleSampleValueInput($any($event.target).checked)"
                                    [disabled]="disabled || readonly"
                                    class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600">
                                <span class="ml-2 text-sm text-gray-700 dark:text-gray-300">
                                    {{ sampleValue ? 'True' : 'False' }}
                                </span>
                            </label>
                        </div>

                        <!-- DateTime Input (valueType === 6) -->
                        <input *ngIf="valueType === 6" type="datetime-local" [value]="sampleValue"
                            (input)="handleSampleValueInput($any($event.target).value)"
                            [disabled]="disabled || readonly"
                            class="w-full px-3 py-2 pr-16 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-slate-800 text-gray-900 dark:text-gray-100 disabled:bg-gray-100 dark:disabled:bg-slate-900 disabled:cursor-not-allowed">

                        <!-- Text Input for all other types (String, Password, Color, PhotoUrl, Link, Guid, etc.) -->
                        <input
                            *ngIf="valueType !== 3 && valueType !== 4 && valueType !== 5 && valueType !== 6 && valueType !== 11"
                            type="text" [value]="sampleValue"
                            (input)="handleSampleValueInput($any($event.target).value)"
                            [disabled]="disabled || readonly"
                            class="w-full px-3 py-2 pr-16 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-slate-800 text-gray-900 dark:text-gray-100 disabled:bg-gray-100 dark:disabled:bg-slate-900 disabled:cursor-not-allowed">

                        <span *ngIf="valueType !== 5"
                            class="absolute right-3 top-1/2 -translate-y-1/2 text-xs tracking-wide text-secondary font-semibold">value</span>
                    </div>
                </div>

                <button type="button"
                    class="frosty blue flex items-center gap-2 px-4 py-2 text-sm font-semibold tracking-tight self-end h-fit"
                    [disabled]="disabled || readonly || !value?.trim()?.length" (click)="triggerManualPreview()">
                    <fa-icon [icon]="['fal', 'play']" size="lg"></fa-icon>
                    <span>{{ 'SystemAdmin.Components.ExpressionEditor.PreviewRun' | translate }}</span>
                </button>
            </div>

            <!-- Variables Section -->
            <div *ngIf="showVariableTools && !compact" class="mb-4">
                <div class="flex items-center justify-between mb-3">
                    <div class="text-sm font-semibold text-gray-700 dark:text-gray-300">
                        {{ 'SystemAdmin.Components.ExpressionEditor.Variables.Title' | translate }}
                    </div>
                    <button type="button" class="frosty text-xs px-3 py-1.5" (click)="addVariableRow()">
                        <fa-icon [icon]="['fal', 'plus']" class="mr-1"></fa-icon>
                        {{ 'SystemAdmin.Components.ExpressionEditor.Variables.Add' | translate }}
                    </button>
                </div>

                <div class="space-y-2">
                    <div class="grid grid-cols-[1fr,140px,auto] gap-3 items-end"
                        *ngFor="let variable of variableInputs; let i = index">
                        <div>
                            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                                {{ 'SystemAdmin.Components.ExpressionEditor.Variables.KeyPlaceholder' | translate }}
                            </label>
                            <input type="text" [value]="variable.key"
                                (input)="updateVariableKey(i, $any($event.target).value)"
                                [disabled]="readonly || disabled"
                                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-slate-800 text-gray-900 dark:text-gray-100 disabled:bg-gray-100 dark:disabled:bg-slate-900 disabled:cursor-not-allowed">
                        </div>

                        <div>
                            <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
                                {{ 'SystemAdmin.Components.ExpressionEditor.Variables.ValuePlaceholder' | translate }}
                            </label>
                            <input type="number" [value]="variable.value"
                                (input)="updateVariableValue(i, $any($event.target).value)"
                                [disabled]="readonly || disabled"
                                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white dark:bg-slate-800 text-gray-900 dark:text-gray-100 disabled:bg-gray-100 dark:disabled:bg-slate-900 disabled:cursor-not-allowed">
                        </div>

                        <button type="button" (click)="removeVariableRow(i)" [disabled]="readonly || disabled"
                            class="p-2 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                            <fa-icon [icon]="['fal', 'trash']"></fa-icon>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Monaco Editor -->
            <div class="mb-4">
                <div
                    class="expression-editor__code-shell rounded-lg border border-gray-200 bg-white dark:border-gray-700 dark:bg-slate-950"
                    [ngClass]="{
                        'expression-editor__code-shell--compact-widget': showQuickExpressionToolbar(),
                        'expression-editor__code-shell--expanded': editorExpanded
                    }">
                    <div *ngIf="showQuickExpressionToolbar()" class="expression-editor__builder-toolbar">
                        <div class="expression-editor__builder-actions">
                            <button
                                type="button"
                                class="expression-editor__builder-button"
                                [matMenuTriggerFor]="expressionColumnsMenu"
                                [matMenuTriggerRestoreFocus]="false"
                                [disabled]="disabled || readonly">
                                <fa-icon [icon]="['fal', 'database']"></fa-icon>
                                <span>{{ 'SystemAdmin.Components.ExpressionEditor.Toolbar.Columns' | translate }}</span>
                                <fa-icon [icon]="['fal', 'chevron-down']" class="text-xs"></fa-icon>
                            </button>

                            <button
                                type="button"
                                class="expression-editor__builder-button"
                                [matMenuTriggerFor]="expressionFunctionsMenu"
                                [matMenuTriggerRestoreFocus]="false"
                                [disabled]="disabled || readonly">
                                <fa-icon [icon]="['fal', 'calculator']"></fa-icon>
                                <span>{{ 'SystemAdmin.Components.ExpressionEditor.Toolbar.Functions' | translate }}</span>
                                <fa-icon [icon]="['fal', 'chevron-down']" class="text-xs"></fa-icon>
                            </button>

                            <button
                                type="button"
                                class="expression-editor__builder-button"
                                [matMenuTriggerFor]="expressionOperatorsMenu"
                                [matMenuTriggerRestoreFocus]="false"
                                [disabled]="disabled || readonly">
                                <fa-icon [icon]="['fal', 'plus']"></fa-icon>
                                <span>{{ 'SystemAdmin.Components.ExpressionEditor.Toolbar.Operators' | translate }}</span>
                            </button>

                            <button
                                type="button"
                                class="expression-editor__builder-button expression-editor__builder-button--compact"
                                [matMenuTriggerFor]="expressionBracketsMenu"
                                [matMenuTriggerRestoreFocus]="false"
                                [disabled]="disabled || readonly">
                                <span class="font-mono text-sm">( )</span>
                                <fa-icon [icon]="['fal', 'chevron-down']" class="text-xs"></fa-icon>
                            </button>
                        </div>

                        <button
                            type="button"
                            class="expression-editor__builder-icon-button"
                            [title]="(editorExpanded ? 'SystemAdmin.Components.ExpressionEditor.Toolbar.Collapse' : 'SystemAdmin.Components.ExpressionEditor.Toolbar.Expand') | translate"
                            (click)="toggleEditorExpanded()">
                            <fa-icon [icon]="getEditorExpandIcon()"></fa-icon>
                        </button>
                    </div>

                    <mat-menu #expressionColumnsMenu="matMenu">
                        <button
                            *ngFor="let column of getToolbarColumns(); trackBy: trackToolbarColumn"
                            type="button"
                            mat-menu-item
                            (click)="insertToolbarColumn(column)">
                            <span>{{ column.label }}</span>
                        </button>
                        <button *ngIf="!getToolbarColumns().length" type="button" mat-menu-item disabled>
                            {{ 'SystemAdmin.Components.ExpressionEditor.Toolbar.NoColumns' | translate }}
                        </button>
                    </mat-menu>

                    <mat-menu #expressionFunctionsMenu="matMenu">
                        <button
                            *ngFor="let fn of widgetToolbarFunctions"
                            type="button"
                            mat-menu-item
                            (click)="insertExpressionText(fn.insertText || fn.label)">
                            <span class="font-mono text-sm">{{ fn.label }}</span>
                        </button>
                    </mat-menu>

                    <mat-menu #expressionOperatorsMenu="matMenu">
                        <button
                            *ngFor="let operator of widgetToolbarOperators"
                            type="button"
                            mat-menu-item
                            (click)="insertExpressionText(operator)">
                            <span class="font-mono text-sm">{{ operator }}</span>
                        </button>
                    </mat-menu>

                    <mat-menu #expressionBracketsMenu="matMenu">
                        <button
                            *ngFor="let bracket of widgetToolbarBrackets"
                            type="button"
                            mat-menu-item
                            (click)="insertExpressionText(bracket, { placeCursorInside: bracket === '()' })">
                            <span class="font-mono text-sm">{{ bracket }}</span>
                        </button>
                    </mat-menu>

                    <div
                        class="expression-editor__editor-frame"
                        [class.shadow-sm]="compact"
                        [class.expression-editor__editor-frame--widget]="showWidgetExpressionEditor()">
                        <ng-container *ngIf="showWidgetExpressionEditor(); else monacoExpressionEditor">
                            <textarea
                                #widgetExpressionInput
                                class="expression-editor__widget-textarea"
                                [style.height.px]="editorExpanded ? editorHeight + 120 : editorHeight"
                                [value]="value"
                                [disabled]="disabled || readonly"
                                spellcheck="false"
                                autocomplete="off"
                                autocapitalize="off"
                                aria-autocomplete="list"
                                [attr.aria-expanded]="widgetSuggestionsOpen"
                                [attr.aria-controls]="widgetSuggestionsOpen ? 'widget-expression-suggestions' : null"
                                (input)="handleWidgetEditorInput(widgetExpressionInput)"
                                (focus)="handleWidgetEditorFocus(widgetExpressionInput)"
                                (blur)="handleWidgetEditorBlur()"
                                (scroll)="handleWidgetEditorScroll(widgetExpressionInput)"
                                (click)="handleWidgetEditorFocus(widgetExpressionInput)"
                                (keyup)="handleWidgetEditorFocus(widgetExpressionInput)"
                                (keydown)="handleWidgetEditorKeydown($event, widgetExpressionInput)"></textarea>

                            <div
                                *ngIf="widgetSuggestionsOpen"
                                id="widget-expression-suggestions"
                                role="listbox"
                                class="expression-editor__suggestions"
                                [style.left.px]="widgetSuggestionPosition.left"
                                [style.top.px]="widgetSuggestionPosition.top"
                                [style.width.px]="widgetSuggestionPosition.width">
                                <button
                                    *ngFor="let suggestion of visibleWidgetSuggestions; let i = index; trackBy: trackWidgetSuggestion"
                                    type="button"
                                    role="option"
                                    class="expression-editor__suggestion"
                                    [class.expression-editor__suggestion--active]="i === widgetSuggestionIndex"
                                    [attr.aria-selected]="i === widgetSuggestionIndex"
                                    (mousedown)="$event.preventDefault()"
                                    (click)="applyWidgetSuggestion(suggestion)">
                                    <span class="expression-editor__suggestion-label">{{ suggestion.label }}</span>
                                    <span class="expression-editor__suggestion-detail" *ngIf="suggestion.detail">
                                        {{ suggestion.detail }}
                                    </span>
                                </button>
                                <div *ngIf="!visibleWidgetSuggestions.length" class="expression-editor__suggestion-empty">
                                    {{ 'SystemAdmin.Components.ExpressionEditor.Toolbar.NoMatches' | translate }}
                                </div>
                            </div>
                        </ng-container>

                        <ng-template #monacoExpressionEditor>
                            <ngx-monaco-editor *ngIf="!editorLoadTimedOut || editorReady"
                                class="expression-editor__editor" [style.height.px]="editorExpanded ? editorHeight + 120 : editorHeight"
                                [options]="editorOptions" [ngModel]="value" (ngModelChange)="handleEditorChange($event)"
                                (onInit)="handleEditorInit($event)" [insideNg]="true">
                            </ngx-monaco-editor>
                            <textarea *ngIf="editorLoadTimedOut && !editorReady"
                                class="expression-editor__fallback block w-full resize-none bg-white px-3 py-3 font-mono text-sm leading-6 text-slate-900 outline-none placeholder:text-slate-400 disabled:cursor-not-allowed disabled:bg-slate-100 disabled:text-slate-500"
                                [style.height.px]="editorExpanded ? editorHeight + 120 : editorHeight"
                                [value]="value"
                                [disabled]="disabled || readonly"
                                spellcheck="false"
                                (input)="handleEditorChange($any($event.target).value)"></textarea>
                        </ng-template>
                    </div>

                    <div *ngIf="showQuickExpressionToolbar()" class="expression-editor__status-bar">
                        <span class="expression-editor__status-pill" [ngClass]="'expression-editor__status-pill--' + getEditorStatusState()">
                            <fa-icon [icon]="getEditorStatusIcon()"></fa-icon>
                            <span *ngIf="validationMessage?.trim(); else translatedEditorStatus" class="expression-editor__status-message">
                                <span class="expression-editor__status-summary">{{ getValidationMessageSummary() }}</span>
                            </span>
                            <ng-template #translatedEditorStatus>
                                <span class="expression-editor__status-message">{{ getEditorStatusLabel() | translate }}</span>
                            </ng-template>
                        </span>
                        <span class="expression-editor__cursor-position">
                            {{ 'SystemAdmin.Components.ExpressionEditor.Toolbar.LineColumn' | translate: { line: cursorLine, column: cursorColumn } }}
                        </span>
                    </div>

                    <div *ngIf="validationMessage?.trim()" class="expression-editor__error-panel">
                        <button
                            *ngIf="hasValidationMessageDetails(); else singleValidationSummary"
                            type="button"
                            class="expression-editor__error-summary"
                            [attr.aria-expanded]="validationDetailsExpanded"
                            (click)="toggleValidationDetails($event)">
                            <fa-icon [icon]="['fal', 'circle-exclamation']"></fa-icon>
                            <span>{{ getValidationMessageSummary() }}</span>
                            <fa-icon
                                [icon]="validationDetailsExpanded ? ['fal', 'chevron-up'] : ['fal', 'chevron-down']"
                                class="expression-editor__error-chevron">
                            </fa-icon>
                        </button>
                        <ng-template #singleValidationSummary>
                            <div class="expression-editor__error-summary expression-editor__error-summary--static">
                                <fa-icon [icon]="['fal', 'circle-exclamation']"></fa-icon>
                                <span>{{ getValidationMessageSummary() }}</span>
                            </div>
                        </ng-template>
                        <pre *ngIf="validationDetailsExpanded && hasValidationMessageDetails()" class="expression-editor__error-details">{{ getValidationMessageDetails() }}</pre>
                    </div>
                </div>

                <div *ngIf="compact && expressionMode === 'widget' && showCompactHints && !showQuickExpressionToolbar()"
                    class="mt-2 flex flex-wrap gap-2 text-[11px] font-semibold text-slate-500">
                    <span class="rounded-lg border border-slate-200 bg-white px-2 py-1">Ctrl/⌘ + Space</span>
                    <span class="rounded-lg border border-slate-200 bg-white px-2 py-1">avg("Column")</span>
                    <span class="rounded-lg border border-slate-200 bg-white px-2 py-1">coalesce(value, "Unknown")</span>
                </div>
            </div>

            <!-- Preview Results -->
            <div *ngIf="enableServerPreview && !compact">
                <div class="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3"
                    *ngIf="previewLoading || previewResult !== null || previewError">
                    <div class="rounded-lg border px-4 py-3 text-sm" [ngClass]="{
                            'border-amber-200 bg-amber-50 text-amber-800': previewLoading,
                            'border-emerald-200 bg-emerald-50 text-emerald-800': !previewLoading && previewError === null && previewResult !== null,
                            'border-rose-200 bg-rose-50 text-rose-800': previewError
                        }">
                        <div class="text-xs tracking-wide font-semibold text-current/70 mb-1">
                            {{ previewLoading
                            ? ('SystemAdmin.Components.ExpressionEditor.PreviewRunning' | translate)
                            : previewError
                            ? ('SystemAdmin.Components.ExpressionEditor.PreviewError' | translate)
                            : ('SystemAdmin.Components.ExpressionEditor.PreviewResult' | translate)
                            }}
                        </div>
                        <div class="text-sm" *ngIf="previewLoading">
                            {{ 'SystemAdmin.Components.ExpressionEditor.PreviewRunningDescription' | translate }}
                        </div>
                        <div class="text-lg font-semibold"
                            *ngIf="!previewLoading && previewError === null && previewResult !== null">
                            {{ previewResult }}
                        </div>
                        <div class="text-sm" *ngIf="!previewLoading && previewError">
                            {{ previewError }}
                        </div>
                    </div>

                    <div class="rounded-lg border border-gray-200 dark:border-gray-700 px-4 py-3 bg-white dark:bg-slate-900/40 text-sm"
                        *ngIf="previewDurationMs !== null">
                        <div class="text-xs tracking-wide text-secondary font-semibold mb-1">
                            {{ 'SystemAdmin.Components.ExpressionEditor.PreviewDuration' | translate }}
                        </div>
                        <div class="text-lg font-semibold text-gray-900 dark:text-gray-100">
                            {{ previewDurationMs | number:'1.0-0' }} ms
                        </div>
                    </div>

                    <div
                        class="rounded-lg border border-gray-200 dark:border-gray-700 px-4 py-3 bg-white dark:bg-slate-900/40 text-sm">
                        <div class="text-xs tracking-wide text-secondary font-semibold mb-1">
                            {{ 'SystemAdmin.Components.ExpressionEditor.SampleValue' | translate }}
                        </div>
                        <div class="text-lg font-semibold text-gray-900 dark:text-gray-100">
                            {{ sampleValue }}
                        </div>
                        </div>
                    </div>

                <!-- Hint -->
                <div
                    class="text-sm leading-relaxed text-secondary bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-3">
                    <fa-icon [icon]="['fal', 'info-circle']" class="mr-2 text-blue-600 dark:text-blue-400"></fa-icon>
                    {{ hint || ('SystemAdmin.Components.ExpressionEditor.Hint' | translate) }}
                    <div class="mt-2 flex flex-wrap gap-x-3 gap-y-1 text-xs font-mono font-semibold">
                        <span
                            class="px-2 py-1 bg-white dark:bg-slate-800 rounded border border-gray-300 dark:border-gray-600">value</span>
                        <span
                            class="px-2 py-1 bg-white dark:bg-slate-800 rounded border border-gray-300 dark:border-gray-600">Math.*</span>
                        <span
                            class="px-2 py-1 bg-white dark:bg-slate-800 rounded border border-gray-300 dark:border-gray-600">?:</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- Library Tab -->
        <div *ngIf="!compact && showLibrary && currentTab === 1">
            <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
                <div>
                    <div class="text-sm font-semibold text-gray-700 dark:text-gray-300">
                        {{ 'SystemAdmin.Components.ExpressionEditor.Library.Title' | translate }}
                    </div>
                    <div class="text-xs text-secondary">
                        {{ 'SystemAdmin.Components.ExpressionEditor.Library.Description' | translate }}
                    </div>
                </div>
                <div class="flex flex-wrap gap-3 text-xs font-semibold">
                    <div
                        class="inline-flex items-center gap-2 px-3 py-1 bg-emerald-50 dark:bg-emerald-900/20 border border-emerald-200 dark:border-emerald-800 rounded-full">
                        <span class="w-2 h-2 rounded-full bg-emerald-500"></span>
                        <span class="text-emerald-700 dark:text-emerald-300">{{
                            'SystemAdmin.Components.ExpressionEditor.Difficulty.Basic' | translate }}</span>
                    </div>
                    <div
                        class="inline-flex items-center gap-2 px-3 py-1 bg-amber-50 dark:bg-amber-900/20 border border-amber-200 dark:border-amber-800 rounded-full">
                        <span class="w-2 h-2 rounded-full bg-amber-500"></span>
                        <span class="text-amber-700 dark:text-amber-300">{{
                            'SystemAdmin.Components.ExpressionEditor.Difficulty.Intermediate' | translate }}</span>
                    </div>
                    <div
                        class="inline-flex items-center gap-2 px-3 py-1 bg-rose-50 dark:bg-rose-900/20 border border-rose-200 dark:border-rose-800 rounded-full">
                        <span class="w-2 h-2 rounded-full bg-rose-500"></span>
                        <span class="text-rose-700 dark:text-rose-300">{{
                            'SystemAdmin.Components.ExpressionEditor.Difficulty.Advanced' | translate }}</span>
                    </div>
                </div>
            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div *ngFor="let template of expressionTemplates"
                    class="rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-slate-900/40 p-4 transition hover:border-blue-400 hover:shadow-md flex flex-col gap-3">
                    <div class="flex items-start justify-between gap-3">
                        <div class="flex-1">
                            <div class="text-sm font-semibold text-gray-900 dark:text-gray-50 mb-1">
                                {{ template.label }}
                            </div>
                            <div class="text-xs text-secondary">
                                {{ template.description }}
                            </div>
                        </div>
                        <div class="w-3 h-3 rounded-full flex-shrink-0" [ngClass]="{
                                    'bg-emerald-500': template.complexity === 'basic',
                                    'bg-amber-500': template.complexity === 'intermediate',
                                    'bg-rose-500': template.complexity === 'advanced'
                                }">
                        </div>
                    </div>
                    <pre
                        class="text-xs font-mono bg-gray-50 dark:bg-slate-950/60 text-gray-700 dark:text-gray-300 rounded-lg p-3 leading-relaxed whitespace-pre-wrap border border-gray-200 dark:border-gray-700">{{ template.expression }}</pre>
                    <button type="button" class="self-start frosty blue text-sm font-semibold tracking-tight px-4 py-2"
                        (click)="applyTemplate(template)">
                        <fa-icon [icon]="['fal', 'download']" class="mr-1"></fa-icon>
                        {{ 'SystemAdmin.Components.ExpressionEditor.Library.UseTemplate' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
